import React, { useState, useEffect } from 'react';
import style from "./index.module.scss";
import {Icon, Input, Table, Select, Balloon, Button } from "@alifd/next";
import LzPagination from "@/components/common/LzPagination";
import { Servlets } from '@/service';

const selectDataSource = [
  { value:101,label:'日常短信'},
  { value:102,label:'女神节'},
  { value:103,label:'618'},
  { value:104,label:'七夕'},
  { value:105,label:'国庆'},
  { value:106,label:'双十一'},
  { value:107,label:'中秋'},
  { value:108,label:'双十二'},
  { value:109,label:'双旦节'},
  { value:110,label:'年货节'},
]
const SystemTemplate = ():JSX.Element => {
  let defaultParams = {
    templateId: '', // 模板名称
    templateContent:'',//短信模板内容 关键字
    // scenes: '', // 短信场景
  }
  // 查询信息
  const [searchParams, setSearchParams] = useState(defaultParams);
  // 翻页信息
  const [searchParams1, setSearchParams1] = useState(defaultParams);
  // 列表loading
  const [listLoading,setListLoading] = useState(false);
  // 短信模板列表数据
  const [tableData, setTableData] = useState([]);
  // 任务列表分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });

  const searchList = (v) => {
    setListLoading(true);
    let params = {
      templateId: searchParams.templateId ? searchParams.templateId : '', // 模板名称
      templateContent:searchParams.templateContent ? searchParams.templateContent : '',//关键字
      // scenes:searchParams.scenes ? searchParams.scenes : '', // 短信场景
      templateType: 1, // 模板类型 0-自定义模板 1-系统模板
      pageNo: 1,
      pageSize: pageInfo.pageSize,
      ...v
    }
    Servlets('getDouDianSMS', params).then((res) => {
      setTableData(res.data);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
      setListLoading(false);
      console.log(res)
    }).catch((e) => {
      console.log(e);
      setListLoading(false);
    })
  }
  // 翻页
  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      searchList({
        templateId: searchParams1.templateId ? searchParams1.templateId : '', // 模板名称
        templateContent:searchParams1.templateContent ? searchParams1.templateContent : '',//关键字
        // scenes:searchParams1.scenes ? searchParams1.scenes : '', // 短信场景
        pageNo: pages.pageNo,
        pageSize: pages.pageSize
      });
    } catch (e) {
      console.log(e);
    }
  }
  const resetList = () => {
    setSearchParams(defaultParams);
    setSearchParams1(defaultParams);
    searchList({
      templateId: '', // 模板名称
      templateContent:'',//关键字
      // scenes:'', // 短信场景
      pageNo: 1,
      pageSize: 10
    });
  }
  // 初始化
  useEffect(() => {
    searchList({
      pageNo: 1,
      pageSize: pageInfo.pageSize
    });
  }, [])

  return(
    <>
      <div className={style.customDefinition}>
        <div className={style['search-box']}>
          <div className={style['search-small-box']}>
            <span>模板ID：</span>
            <Input
              name='templateId'
              placeholder="请输入模板ID"
              style={{width:'60%'}}
              value={searchParams.templateId}
              onChange={(v)=>{setSearchParams({...searchParams,templateId:v})}}
            />
          </div>
          <div className={style['search-small-box']}>
            <span>关键字：</span>
            <Input
              name='templateContent'
              placeholder="请输入关键字"
              style={{width:'60%'}}
              value={searchParams.templateContent}
              onChange={(v)=>{setSearchParams({...searchParams,templateContent:v})}}
            />
          </div>
          {/* <div className={style['search-small-box']}>
            <span>短信场景：</span>
            <Select
              name='scenes'
              dataSource={selectDataSource}
              value={searchParams.scenes}
              onChange={(v)=>{setSearchParams({...searchParams,scenes:v})}}
              style={{width:'74%'}}
            />
          </div> */}
          <div className={style['search-small-box2']}>
            <Button
              type='primary'
              className={`${style.w88} ${style.mr10}`}
              onClick={()=>{
                searchList({ pageNo: 1 });
                setSearchParams1({...searchParams});
              }}
            >
              查询
            </Button>
            <Button
              type='normal'
              className={style.w88}
              onClick={resetList}
            >
              重置
            </Button>
          </div>
        </div>
        <div className={style.card}>
          <div className={style.table}>
            <Table dataSource={tableData} loading={listLoading}>
              <Table.Column title="模板ID" dataIndex="templateId" width={200}/>
              {/* <Table.Column
                title="短信场景"
                dataIndex="scenes"
                width={200}
                cell={(value, index, record) => {
                  return (
                    <div>
                      {record.scenes===101 && '日常短信'}
                      {record.scenes===102 && '女神节'}
                      {record.scenes===103 && '618'}
                      {record.scenes===104 && '七夕'}
                      {record.scenes===105 && '国庆'}
                      {record.scenes===106 && '双十一'}
                      {record.scenes===107 && '中秋'}
                      {record.scenes===108 && '双十二'}
                      {record.scenes===109 && '双旦节'}
                      {record.scenes===110 && '年货节'}
                    </div>
                  )
                }}
              /> */}
              <Table.Column
                title="短信内容"
                dataIndex="templateContent"
                cell={(value, index, record) => {
                  return (
                    <div>
                      <span>{record.templateContent}</span>
                      <Balloon
                        trigger={
                          <Button type='primary' text className={style.ml5}>
                            <div style={{height:'12px',lineHeight:'8px'}}>详情</div>
                          </Button>
                        } 
                        closable={false}
                        align="t" 
                        popupClassName={style.pop}
                      >
                        {record.templateContent}
                      </Balloon>
                    </div>
                  )
                }}
              />
              <Table.Column
                title="字数/计费条数"
                dataIndex="templateContent"
                width={200}
                cell={(value) => {
                  if (value.length <= 70) {
                    return <span>{value.length}/1</span>
                  } else {
                    const num = Math.ceil(value.length/67)
                    return <span>{value.length}/{num}</span>
                  }
                }}
              />
            </Table>
            <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
          </div>
        </div>
      </div>
    </>
  )
}

export default SystemTemplate;
